import { render } from "./ZodiacAnalysis.vue?vue&type=template&id=92e61d46"
import script from "./ZodiacAnalysis.vue?vue&type=script&lang=js"
export * from "./ZodiacAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__